import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";

export const PHONE = "07 45 04 91 89";
export const PHONE_LINK = "tel:+33745049189";
export const EMAIL = "dmznormandie@gmail.com";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ overline, title, center = false }) {
  return (
    <Reveal className={`mb-12 lg:mb-16 ${center ? "text-center" : ""}`}>
      <p className="text-[10px] tracking-[0.5em] uppercase text-[#C4A484] mb-4">{overline}</p>
      <h2 className="font-serif-display font-light text-4xl md:text-5xl tracking-tight text-[#F5F5F0]">{title}</h2>
    </Reveal>
  );
}

export function PageHero({ title, subtitle }) {
  return (
    <section className="bg-[#0D0D0D] border-b border-white/10 pt-40 pb-20 lg:pt-48 lg:pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <p className="text-[10px] tracking-[0.5em] uppercase text-[#C4A484] mb-5">DMZ Normandie — Bernay · Eure</p>
          <h1 className="font-serif-display font-light text-4xl md:text-6xl tracking-tight text-[#F5F5F0] max-w-3xl leading-[1.05]">
            {title}
          </h1>
          {subtitle && <p className="mt-6 max-w-2xl text-base md:text-lg font-light text-zinc-400 leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}

export function CTABand() {
  return (
    <section className="bg-[#121212] border-t border-white/10 py-20 lg:py-28" data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <h2 className="font-serif-display font-light text-3xl md:text-5xl tracking-tight text-[#F5F5F0] max-w-3xl mx-auto leading-tight">
            Vous avez un projet de construction ou de rénovation ?
          </h2>
          <p className="mt-5 text-zinc-400 font-light max-w-xl mx-auto">
            Contactez DMZ Normandie pour obtenir votre devis gratuit. Intervention à Bernay, dans l'Eure et en Normandie.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="btn-sable" data-testid="cta-devis-button">
              Demander un devis <ArrowRight size={16} />
            </Link>
            <a href={PHONE_LINK} className="btn-outline-light" data-testid="cta-call-button">
              <Phone size={16} /> Appeler DMZ Normandie
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
